@for (status of statuses; track status) {
  <div class="statusButton__row" (click)="selectOption(status)">
    <pp-status-button [ppStatus]="status"></pp-status-button>
  </div>
}
